import i18next from "i18next";

/** The four customer-facing regions, by code. Mirrors the API's own label table. */
const LABELS = {
  europe: "regions.europe",
  america: "regions.america",
  asia: "regions.asia",
  australia: "regions.australia",
} as const;

/**
 * The name of a workload's region: the label for a code we know, the code
 * itself for one we do not — never nothing for something that is somewhere —
 * and null before the workload has been placed.
 *
 * A fact, never a control. An app or database cannot move: it reaches its
 * neighbours by container name on one server, so its region is chosen when
 * it is created and fixed after.
 */
export function regionLabel(code: string | null | undefined): string | null {
  if (!code) return null;
  const key = (LABELS as Record<string, (typeof LABELS)[keyof typeof LABELS] | undefined>)[code];
  return key ? i18next.getFixedT(null, "common")(key) : code;
}
